import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBanner } from './components/TopBanner';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { HooksSection } from './components/HooksSection';
import { LearnSection } from './components/LearnSection';
import { SocialProofSection } from './components/SocialProofSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { UrgencySection } from './components/UrgencySection';
import { FinalCTASection } from './components/FinalCTASection';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-whatsapp selection:text-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBanner data-id="element-2" />
      <CountdownBar data-id="element-3" />
      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <HooksSection data-id="element-6" />
        <LearnSection data-id="element-7" />
        <SocialProofSection data-id="element-8" />
        <HowItWorksSection data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <FinalCTASection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <FloatingWhatsApp data-id="element-13" />
    </div>;
}